import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'pages.careerRoadmap.title',
    defaultMessage: 'Career Roadmap',
  },
});
